export default __webpack_public_path__ + "static/media/12.c943b8a4.png";